/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Point_Security_TitleInputs */

const en_contact_point_security_title = /** @type {(inputs: Contact_Point_Security_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Security reviewed up front`)
};

/**
* | output |
* | --- |
* | "Security reviewed up front" |
*
* @param {Contact_Point_Security_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const contact_point_security_title = /** @type {((inputs?: Contact_Point_Security_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Point_Security_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_contact_point_security_title(inputs)
});